export default __webpack_public_path__ + "static/Mont-LightItalic-84a3385a41244e5aed1120c224f0488d.otf";